export const hasPopup = item => {
    const SECTIONS_WITH_POPUP = [
      'AdvancedReport',
      'SectionTitle',
      'CoverPage',
      'LifeInsurance',
      'ComparePlans',
      'ProtectLiveDream',
    ];

    if (item.type === 'BeFi20' && item.editableFields) {
      SECTIONS_WITH_POPUP.push('BeFi20');
    }

    if (item.type === 'LivingBalanceSheet' && item.editableFields) {
      SECTIONS_WITH_POPUP.push('LivingBalanceSheet');
    }

    return SECTIONS_WITH_POPUP.find(type => type === item.type);
  },
  hasDelete = item => {
    const SECTIONS_WITH_DELETE = ['AdvancedReport', 'SectionTitle'];
    return SECTIONS_WITH_DELETE.find(type => type === item.type);
  },
  hasExpando = item => {
    if (!item.editableFields) {
      return false;
    }
    return !hasPopup(item);
  },
  itemTitleInSortList = item => {
    switch (item.type) {
      case 'AdvancedReport':
        return item.editableFields.selectedReport
          ? `Report: ${item.editableFields.selectedReport}`
          : 'Report';
      case 'SectionTitle':
        return item.editableFields.title ? `Section: ${item.editableFields.title}` : 'Section';
      default:
        return item.title;
    }
  },
  itemTypeFromDropdownLabel = dropdownLabel => {
    const TYPES_FROM_DROPDOWN_LABEL = {
      Report: 'AdvancedReport',
      Section: 'SectionTitle',
    };
    return TYPES_FROM_DROPDOWN_LABEL.hasOwnProperty(dropdownLabel)
      ? TYPES_FROM_DROPDOWN_LABEL[dropdownLabel]
      : dropdownLabel;
  },
  itemFromOptionLabel = (optionLabel, items) => {
    const type = itemTypeFromDropdownLabel(optionLabel);
    return items.filter(itm => itm.hidden).find(itm => itm.type === type);
  },
  getPreventDropOn = item => {
    return hasDelete(item) || item.nonExcludable ? 'excluded' : undefined;
  },
  getInsertPageOptionList = items => {
    const list = ['Section', 'Report'];
    return list;
  };
